import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/ConsentPopup.css'; // We'll create this CSS file next

const CONSENT_KEY = 'userConsentAccepted_v1'; // Keep this key

const ConsentPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem(CONSENT_KEY);
    // Also check if it was temporarily dismissed in this session
    const sessionDismissed = sessionStorage.getItem('consentPopupDismissed_v1');

    if (!consentGiven && !sessionDismissed) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    // Temporarily dismiss for the current session
    sessionStorage.setItem('consentPopupDismissed_v1', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="consent-popup-overlay">
      <div className="consent-popup">
        <button onClick={handleDismiss} className="consent-popup-dismiss-button" aria-label="Dismiss consent popup">
          × {/* HTML entity for 'X' (multiplication sign) */}
        </button>
        <div className="consent-popup-content">
          <h3 className="consent-popup-title">Your Privacy Matters</h3>
          <p className="consent-popup-text">
            We use cookies and similar technologies to enhance your experience,
            analyze site traffic, and for marketing purposes. By clicking "Accept,"
            you agree to our use of these technologies as described in our
            {' '}<Link to="/privacy" className="consent-popup-link">Privacy Policy</Link> and
            {' '}<Link to="/terms" className="consent-popup-link">Terms & Conditions</Link>.
          </p>
        </div>
        <div className="consent-popup-actions">
          <button onClick={handleAccept} className="consent-popup-button">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;